import { yupResolver } from '@hookform/resolvers/yup';
import {
  CustomButton,
  CustomInputCheckBox,
  CustomTextInput,
} from '@Modules/core/components';
import AppLoader from '@Modules/core/components/Loader';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IPasswordSettingMeta } from '../../containers/formHandlers/PasswordSettingsFormHandle/PasswordFettingsFormMeta';

type Props = {
  onSubmit: any,
  meta: IPasswordSettingMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default React.forwardRef(function PasswordSettingFormUI(
  { onSubmit, meta, isLoading, isSubmitting }: Props,
  ref
) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    reset,
  }));

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CC.Box>
          <CC.Text mb="4" color="gray.600">
            {/* Remplissez les informations de base du profile */}
            {isLoading && <AppLoader />}
          </CC.Text>

          <CC.Box w="full" mt={{ base: 0, md: 4 }} mb={{ base: 4, md: 8 }}>
            <CC.Flex
              w="full"
              mb={{ base: 2, md: 4 }}
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CC.FormControl mr="2">
                <CC.FormLabel>Longeur Minimale</CC.FormLabel>
                <CustomTextInput
                  meta={meta.minLength}
                  register={register(meta.minLength.name)}
                  hasError={errors[meta.minLength.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>Longeur Maximale</CC.FormLabel>
                <CustomTextInput
                  meta={meta.maxLength}
                  register={register(meta.maxLength.name)}
                  hasError={errors[meta.maxLength.name]}
                />
              </CC.FormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              mb={{ base: 2, md: 4 }}
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CC.FormControl mr="2">
                <CC.FormLabel>Limit de tentative</CC.FormLabel>
                <CustomTextInput
                  meta={meta.attemptLimit}
                  register={register(meta.attemptLimit.name)}
                  hasError={errors[meta.attemptLimit.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>Nombre de sessions</CC.FormLabel>
                <CustomTextInput
                  meta={meta.sessionsNumber}
                  register={register(meta.sessionsNumber.name)}
                  hasError={errors[meta.sessionsNumber.name]}
                />
              </CC.FormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              mb={{ base: 2, md: 4 }}
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CC.FormControl mr="2">
                <CC.FormLabel>Nombre de jours avant expiration</CC.FormLabel>
                <CustomTextInput
                  meta={meta.nbOfDayBeforeExpiration}
                  register={register(meta.nbOfDayBeforeExpiration.name)}
                  hasError={errors[meta.nbOfDayBeforeExpiration.name]}
                />
              </CC.FormControl>

              <CC.FormControl>
                <CC.FormLabel>Nombre de jours alerte expiration</CC.FormLabel>
                <CustomTextInput
                  meta={meta.nbOfDayExpirationAlert}
                  register={register(meta.nbOfDayExpirationAlert.name)}
                  hasError={errors[meta.nbOfDayExpirationAlert.name]}
                />
              </CC.FormControl>
            </CC.Flex>

            <CC.Stack>
              <CC.FormControl>
                <CC.Flex alignItems="center">
                  <CustomInputCheckBox
                    meta={meta.changeOnFirstLogin}
                    register={register(meta.changeOnFirstLogin.name)}
                    hasError={errors[meta.changeOnFirstLogin.name]}
                  />
                  <CC.FormLabel ml="4" mt="2">
                    {meta.changeOnFirstLogin.label}
                  </CC.FormLabel>
                </CC.Flex>
              </CC.FormControl>
            </CC.Stack>
          </CC.Box>

          <CC.Flex justify={'flex-end'}>
            <CustomButton loading={isSubmitting} type="submit" >
              Sauvegarder
            </CustomButton>

            {/* <CustomButton type="button">
            {isLoading ? (
              <AppLoader />
            ) : (
              <span>Sauvegarder et continuer</span>
            )}
          </CustomButton> */}
          </CC.Flex>
        </CC.Box>
      </form>
    </>
  );
});
